const booksData = [
  {
    seriesName: 'Sam Norris Murder Mysteries',
    books: [
      {
        id: 1,
        seriesName: 'SNMM',
        bookNumber: 1,
        title: 'Manufacturing Murder',
        cover: '/images/Evanoff_ManufacturingMurder_Ebook.jpg',
        description: 'Meet Sam Norris, a software developer whose latest creation for a midsize company promises to revolutionize their manufacturing plants.',
        longDescription: 'A routine software installation turns into a race against time and death...<br><br>Meet Sam Norris, a software developer whose latest creation for a midsize company promises to revolutionize their manufacturing plants. He and his team travel to a remote city in Wyoming to implement the new system, but what they find is far from ordinary.<br><br><b>When the plant manager turns up dead, a whirlwind of suspects with hidden motives surfaces.</b><br><br> Amidst the chaos, Sam crosses paths with Dani, a night shift worker at the plant. Drawn to her magnetic presence, they forge a connection even as she becomes the prime suspect in the eyes of the police. As Sam grapples with his own secrets, he\'s determined to uncover the truth and clear Dani\'s name.<br><br><b>But when a second body is discovered, the stakes are raised even higher.</b><br><br>Can Sam solve the murders and save Dani from being wrongly accused? Will he be able to stop the killer before becoming the next victim?<br><br>Dive into this gripping murder mystery filled with unexpected twists, nail-biting cliffhangers, and a plot that will keep you turning pages well into the night.<br><br><b>Don\'t wait – immerse yourself in Manufacturing Murder now!</b>',
        currentStatus: '',
        heroDescription: 'Manufacturing Murder: A gripping murder mystery filled with unexpected twists, nail-biting suspense, and a race against time. Join software developer Sam Norris on a routine installation that turns deadly. When the plant manager is found dead, Sam teams up with Dani, a night shift worker and prime suspect, to uncover the truth. As the body count rises, can Sam solve the murders and save Dani from being wrongly accused? Dive into this thrilling page-turner and unravel the secrets before it\'s too late.',
        freeGiveawayDescription: '',
        buyLink: 'https://www.amazon.com/dp/B0C1W9D7CS?maas=maas_adg_08D9EE5F6CC854C4FF53B35156191C8B_afap_abs&ref_=aa_maas&tag=maas',
        buyButtonText: 'More Info',
        showBuyButton: true,
        paperbackBuyButtonText: 'Paperback',
        showPaperbackBuyButton: true,
        showBook: true,
        category: 'murderMystery',
        readingOrder: '1',
        readingOrderDescription: '',
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 100,
        bookStatus: 'Published',
        heroOrder: '1',
        next: false,
        nextDescription: '',
        landingPage: false,
        landingPageDescription: 'A murder during a routine software installation.',
        publishedDate: '05/09/2023',
        readingOrderBookNumber: 1,
        webLink: '/books/manufacturing-murder'
      },
      {
        id: 2,
        seriesName: 'SNMM',
        bookNumber: 2,
        title: 'Inheriting Murder',
        cover: '/images/CoverBook2.jpg',
        description: 'Now available',
        longDescription: '<b>At Savannah Palms Golf Course, the most dangerous hazards aren’t along the fairways.</b><br><br><b>Sam Norris</b> returned home to Savannah for a quiet life, to work on <b>his new relationship</b> and to perfect his golf swing. But when the patriarch of the legendary Savannah Palms Golf Course <b>dies</b>, the reading of his will unearths a legacy of greed that threatens to <b>tear a family apart</b>.<br><br>The tragedy takes a <b>brutal turn</b> when a member of the family dies only minutes after the will is read. Days later, <b>it gets worse</b> when Sam’s best friend, Carey Layne, is found standing over <b>another dead body</b> holding the bloody weapon. To the police, it’s an open-and-shut case.<br><br><b>Sam sees it a different way.</b><br><br><b>And clearing Carey’s name requires seeing what everyone else has missed.</b><br><br>As Sam navigates a world of <b>secret affairs</b>, Las Vegas ghosts and family feuds, he also finds himself reintroduced to the city’s <b>most famous cold case:</b> a local girl who vanished <b>without a trace</b> seventeen years ago. In a town where everyone is <b>hiding something</b>, Sam must use his unique abilities to <b>unmask a killer</b> who has perfected the <b>art of the lie</b>.<br><br><b>At Savannah Palms Golf Course, the past is never truly gone, and the killer is still on the green.</b>',
        heroDescription: '',
        currentStatus: '',
        freeGiveawayDescription: '',
        buyLink: 'https://www.amazon.com/dp/B0GX2YHJG4?maas=maas_adg_1C827B7B6F4B4F456093863079817DAA_afap_abs&ref_=aa_maas&tag=maas',
        buyButtonText: 'More Info',
        showBuyButton: true,
        paperbackBuyButtonText: 'Paperback',
        showPaperbackBuyButton: true,
        showBook: true,
        category: 'murderMystery',
        readingOrder: '2',
        readingOrderDescription: '',
        showInHero: true,
        showInFreeGiveaway: false,
        progress: 100,
        bookStatus: 'Published',
        heroOrder: '1',
        comingSoon: '2',
        comingSoonDescription: 'Sam is back in Savannah. When his best friend\'s older brother dies and his best friend is arrested, he\'s pulled back into another mystery.',
        next: false,
        nextDescription: 'When his best friend is <b>framed</b> for a brutal <b>murder</b> following a contentious will reading, tech-savvy Sam Norris is drawn into a <b>labyrinth</b> of family secrets. <br><br> To clear his friendʼs name, Sam must unravel a web of <b>blackmail</b>, greed, and a seventeen-year-old cold case. <br><br>But as he gets <b>closer</b> to the truth, he discovers the <b>killer</b> might be someone he <b>trusts</b> the most, and every revelation puts him in <b>greater</b> danger',
        status: 6,
        landingPage: true,
        landingPageDescription: 'A death after a will reading starts a downward spiral for a family.',
        publishedDate: '04/28/2026',
        readingOrderBookNumber: 2,
        webLink: '/books/inheriting-murder'
      },
      {
        id: 3,
        seriesName: "SNMM",
        bookNumber: 3,
        title: "Networking Murder",
        cover: '/images/CoverBook3.jpg',
        description: "Sam Norris thought his father’s secrets died with him. He was wrong. When an anonymous user named SavannahCoder88 promises documents about Sam’s late father, Myles Norris, Sam is drawn into Orion Innovations, a company hiding far more than office politics and bad code. Before long, he stumbles into a murder scene. He soon learns the dead man, Gregory Hale, was building something dangerous: a secret project called Prometheus, one that could destroy lives far beyond Savannah. If Hale was about to expose it, someone had every reason to silence him. The danger follows him outside Orion. During dinner with his girlfriend, Dani, Sam notices a man watching them. Minutes later, the stranger makes a grab for Dani’s bag, then disappears into the night, leaving behind one chilling clue: a black chess rook. Then security throws Sam out, and SavannahCoder88 goes silent. Cut off from the one person who promised answers, Sam is forced to keep digging from the outside while Orion closes ranks around him. With the truth about his father slipping farther out of reach and someone willing to send a message straight to Dani, Sam is no longer chasing a mystery. He’s now in someone’s crosshairs. With his father’s legacy on the line and a deadly secret hidden inside Orion, Sam must uncover the truth before he is framed, silenced, or deleted for good.",
        longDescription: "",
        heroDescription: "",
        freeGiveawayDescription: "",
        buyLink: "https://www.amazon.com/dp/B0GX51MQ1C?maas=maas_adg_A9D20D413C6A3230C04796FD786AE637_afap_abs&ref_=aa_maas&tag=maas",
        buyButtonText: "More Info",
        showBuyButton: true,
        paperbackBuyButtonText: "",
        showPaperbackBuyButton: true,
        showBook: true,
        category: "murderMystery",
        readingOrder: "3",
        readingOrderDescription: "",
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 60,
        bookStatus: "First Draft Finished",
        heroOrder: "",
        comingSoon: "",
        comingSoonDescription: "",
        next: true,
        nextDescription: "<b>Sam Norris thought his father’s secrets died with him.</b><br><br><b>He was wrong.</b><br><br>When an anonymous source promises files about Sam’s late father, Sam is pulled into Orion Innovations, where hidden agendas and dangerous code lead him straight to a murder.<br><br><b>Then the warning turns personal.</b><br><br>After a stranger targets Dani and leaves behind a black chess rook, Sam realizes this mystery reaches far beyond one dead man. Someone is protecting a secret project called <b>Prometheus</b>, and they’ll do whatever it takes to keep it buried.<br><br><b>Now Sam must uncover the truth before his father’s past gets him killed too</b>.",
        status: 3,
        publishedDate: "",
        readingOrderBookNumber: 3,
      },
      {
        id: 4,
        seriesName: "SNMM",
        bookNumber: 4,
        title: "TBD",
        cover: "",
        description: "",
        longDescription: "",
        heroDescription: "",
        freeGiveawayDescription: "",
        buyLink: "",
        buyButtonText: "",
        showBuyButton: false,
        paperbackBuyButtonText: "",
        showPaperbackBuyButton: false,
        showBook: false,
        category: "murderMystery",
        readingOrder: "4",
        readingOrderDescription: "",
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 50,
        bookStatus: "First Draft Finished",
        heroOrder: "",
        comingSoon: "",
        comingSoonDescription: "",
        next: false,
        nextDescription: "",
        status: 0,
        publishedDate: "",
        readingOrderBookNumber: 4,
      },
      {
        id: 5,
        seriesName: "SNMM",
        bookNumber: 5,
        title: "TBD",
        cover: "",
        description: "",
        longDescription: "",
        heroDescription: "",
        freeGiveawayDescription: "",
        buyLink: "",
        buyButtonText: "",
        showBuyButton: false,
        paperbackBuyButtonText: "",
        showPaperbackBuyButton: false,
        showBook: false,
        category: "murderMystery",
        readingOrder: "5",
        readingOrderDescription: "",
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 50,
        bookStatus: "First Draft Finished",
        heroOrder: "",
        comingSoon: "",
        comingSoonDescription: "",
        next: false,
        nextDescription: "",
        status: 0,
        publishedDate: "",
        readingOrderBookNumber: 5,
      },
      {
        id: 6,
        seriesName: "SNMM",
        bookNumber: 6,
        title: "TBD",
        cover: "",
        description: "",
        longDescription: "",
        heroDescription: "",
        freeGiveawayDescription: "",
        buyLink: "",
        buyButtonText: "",
        showBuyButton: false,
        paperbackBuyButtonText: "",
        showPaperbackBuyButton: false,
        showBook: false,
        category: "murderMystery",
        readingOrder: "6",
        readingOrderDescription: "",
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 50,
        bookStatus: "First Draft Finished",
        heroOrder: "",
        comingSoon: "",
        comingSoonDescription: "",
        next: false,
        nextDescription: "",
        status: 0,
        publishedDate: "",
        readingOrderBookNumber: 6,
      },
      {
        id: 7,
        seriesName: "SNMM",
        bookNumber: 7,
        title: "TBD",
        cover: "",
        description: "",
        longDescription: "",
        heroDescription: "",
        freeGiveawayDescription: "",
        buyLink: "",
        uyButtonText: "",
        showBuyButton: false,
        paperbackBuyButtonText: "",
        showPaperbackBuyButton: false,
        showBook: false,
        category: "murderMystery",
        readingOrder: "7",
        readingOrderDescription: "",
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 50,
        bookStatus: "First Draft Finished",
        heroOrder: "",
        comingSoon: "",
        comingSoonDescription: "",
        next: false,
        nextDescription: "",
        status: 0,
        publishedDate: "",
        readingOrderBookNumber: 7,
      },
      {
        id: 8,
        seriesName: "SNMM",
        bookNumber: 8,
        title: "TBD",
        cover: "",
        description: "",
        longDescription: "",
        heroDescription: "",
        freeGiveawayDescription: "",
        buyLink: "",
        buyButtonText: "",
        showBuyButton: false,
        paperbackBuyButtonText: "",
        showPaperbackBuyButton: false,
        showBook: false,
        category: "murderMystery",
        readingOrder: "8",
        readingOrderDescription: "",
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 50,
        bookStatus: "First Draft Finished",
        heroOrder: "",
        comingSoon: "",
        comingSoonDescription: "",
        next: false,
        nextDescription: "",
        status: 0,
        publishedDate: "",
        readingOrderBookNumber: 8,
      },
      {
        id: 9,
        seriesName: "SNMM",
        bookNumber: 9,
        title: "TBD",
        cover: "",
        description: "",
        longDescription: "",
        heroDescription: "",
        freeGiveawayDescription: "",
        buyLink: "",
        buyButtonText: "",
        showBuyButton: false,
        paperbackBuyButtonText: "",
        showPaperbackBuyButton: false,
        showBook: false,
        category: "murderMystery",
        readingOrder: "9",
        readingOrderDescription: "",
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 50,
        bookStatus: "First Draft Finished",
        heroOrder: "",
        comingSoon: "",
        comingSoonDescription: "",
        next: false,
        nextDescription: "",
        status: 0,
        publishedDate: "",
        readingOrderBookNumber: 9,
      }
    ],
  },
  {
    seriesName: 'Sam Norris Short Stories',
    books: [
      {
        id: 10,
        seriesName: 'SNMM',
        bookNumber: 1.5,
        title: 'The Library',
        cover: '/images/TheLibrary.jpg',
        shortDescription: '',
        description: 'Short Story that happens between Manufacturing Murder and Inheriting Murder',
        longDescription: 'In the heart of Savannah, Sam and Dani race against time to uncover the truth behind a mysterious ledger that could give Sam the proof he needs to uncover the mystery of his parents\' death.<br><br>When they meet the elusive Fox, he sends down on a dangerous path filled with intrigue and deception.<br><br>As they delve deeper into the conspiracy, they realize that their own lives may be in danger. Will Sam find the ledger before his pursuers?<br><br>Will they be able to unravel the truth before it\'s too late?',
        currentStatus: '',
        heroDescription: '',
        freeGiveawayDescription: 'Nightmares Through Time',
        buyLink: 'https://BookHip.com/JBLGHJZ',
        buyButtonText: 'Get Free!',
        showBuyButton: true,
        paperbackBuyButtonText: 'Paperback',
        showPaperbackBuyButton: false,
        showBook: true,
        category: 'murderMystery',
        readingOrderDescription: '',
        readingOrder: '1.5',
        bookStatus: 'Published',
        showInHero: false,
        showInFreeGiveaway: true,
        progress: 100,
        heroOrder: '1',
        next: false,
        nextDescription: '',
        readingOrderBookNumber: 1.5,
      },
      {
        id: 11,
        seriesName: 'SNMM',
        bookNumber: 0.5,
        title: 'The Puppeteer',
        cover: '/images/Puppeteer.jpg',
        shortDescription: '',
        description: '',
        longDescription: '',
        currentStatus: '',
        heroDescription: '',
        freeGiveawayDescription: 'Sam Norris Murder Mystery Stories',
        buyLink: '',
        buyButtonText: 'Get Free!',
        showBuyButton: false,
        paperbackBuyButtonText: 'Paperback',
        showPaperbackBuyButton: false,
        showBook: false,
        category: 'murderMystery',
        readingOrderDescription: '',
        readingOrder: '0.5',
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 50,
        heroOrder: '1',
        comingSoon: '1',
        comingSoonDescription: 'Go back to the beginning and watch a young, just out of college, Sam Norris, solve his first case.',
        bookStatus: '',
        next: false,
        nextDescription: '',
        readingOrderBookNumber: 3.5,
      },
      {
        id: 18,
        seriesName: "SNMM",
        bookNumber: 4.5,
        title: "TBD",
        cover: "",
        description: "",
        longDescription: "",
        heroDescription: "",
        freeGiveawayDescription: "",
        buyLink: "",
        buyButtonText: "",
        showBuyButton: false,
        paperbackBuyButtonText: "",
        showPaperbackBuyButton: false,
        showBook: false,
        category: "murderMystery",
        readingOrder: '4.5',
        readingOrderDescription: "",
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 10,
        bookStatus: "Plotted",
        heroOrder: "",
        comingSoon: "",
        comingSoonDescription: "",
        next: false,
        nextDescription: "",
        status: 0,
        publishedDate: "",
        readingOrderBookNumber: 4.5,
      },
      {
        id: 18,
        seriesName: "SNMM",
        bookNumber: 7.5,
        title: "TBD",
        cover: "",
        description: "",
        longDescription: "",
        heroDescription: "",
        freeGiveawayDescription: "",
        buyLink: "",
        buyButtonText: "",
        showBuyButton: false,
        paperbackBuyButtonText: "",
        showPaperbackBuyButton: false,
        showBook: false,
        category: "murderMystery",
        readingOrder: '7.5',
        readingOrderDescription: "",
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 50,
        bookStatus: "First Draft Finished",
        heroOrder: "",
        comingSoon: "",
        comingSoonDescription: "",
        next: false,
        nextDescription: "",
        status: 0,
        publishedDate: "",
        readingOrderBookNumber: 7.5,
      },    ],
  },
  {
    seriesName: 'Nightmares Through Time',
    books: [
      {
        id: 12,
        bookNumber: 1,
        seriesName: 'NTT',
        title: 'Forgetting Tomorrow',
        cover: '/images/Evanoff_ForgettingTomorrow_Ebook.jpg',
        description: 'Book 1 in the Nightmares Through Time series.',
        longDescription: '<b>Which door would you choose?</b><br><br>Peter lives in the world of IT. It’s not glamorous. He’s bored. At least he has Anna in graphic design. She makes coming to work tolerable.<br><br><b>How can he win her over?</b><br><br>At the end of each day, Peter heads home alone and sits in his living room, tinkering with his secret project. The day it worked, he discovered his future was full of death and destruction, possibly of his own doing. Would he regret his choice to use it?<br><br><b>After Anna finds out his secret, his worlds collide.</b><br><br>With a host of new possibilities, his life has changed forever, but the path he’s on isn’t heading where he thinks, and Peter will have to face the worst decision imaginable.<b>Will he choose to save Anna or humanity?</b><br><br>You’ll love this time-travel mystery adventure, because of the twists, turns, and an ending you’ll never guess.',
        currentStatus: '',
        heroDescription: '',
        freeGiveawayDescription: '',
        buyLink: 'https://www.amazon.com/dp/B07TXX6T1H?maas=maas_adg_8B3AFFE84C4AAB0E2300FE457F0651FD_afap_abs&ref_=aa_maas&tag=maas',
        buyButtonText: 'More Info',
        showBuyButton: true,
        paperbackBuyButtonText: 'Paperback',
        showPaperbackBuyButton: false,
        showBook: true,
        category: 'timeTravel',
        readingOrder: '1',
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 100,
        heroOrder: '1',
        next: false,
        nextDescription: '',
      },
      {
        id: 13,
        seriesName: 'NTT',
        bookNumber: 2,
        title: 'Spark',
        cover: '/images/Evanoff_Spark_Ebook.jpg',
        description: 'Book 2 in the Nightmares Through Time series.',
        longDescription: '<b>She wanted to change the world</b><br><br>A near-fatal lightning strike ended her life.<br><br>When her conscience is pulled into a realm of death and destruction, she’ll get a second chance.<br><br>Everything was going well for Linda. She had just graduated from college, started a new job and met a man. One rainy evening, she is struck by lightning and sent into a coma, seemingly ending her life.><br><br><b>Until a mysterious voice calls out to her.</b><br><br>She follows the voice and is brought into the future, witnessing events before and after an incident that destroys the world. She is told she’s the chosen one, the one who will save everyone, but she can only do it by following a boy who holds the key to time travel. And she must do it while stuck inside the machinery.<br><br><b>But unbeknownst to Linda, enemies are gathering.</b><br><br>Can she stop them before they discover her secret? Can she keep them from harming her allies? Will she figure out the puzzle laid before her to save humanity?<br><br>Spark is the second book in the Nightmares Through Time science-fiction, time-travel and dystopian series. It features action-packed suspense with a twist that will keep you turning pages well into the night.',
        currentStatus: '',
        heroDescription: '',
        freeGiveawayDescription: '',
        buyLink: 'https://www.amazon.com/dp/B08CSXMJQ3?maas=maas_adg_121D54A9E1D717B4F67EC323D75B3F08_afap_abs&ref_=aa_maas&tag=maas',
        buyButtonText: 'More Info',
        showBuyButton: true,
        paperbackBuyButtonText: 'Paperback',
        showPaperbackBuyButton: false,
        showBook: true,
        category: 'timeTravel',
        readingOrder: '5',
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 100,
        heroOrder: '1',
        next: false,
        nextDescription: '',
      },
      {
        id: 14,
        seriesName: 'NTT',
        bookNumber: 3,
        title: 'Revolution',
        cover: '/images/Evanoff_Revolution_Ebook.jpg',
        description: 'Book 3 in the Nightmares Through Time series. (IN PROGRESS)',
        longDescription: 'This book is currently in process.<br><br>It will follow the journey of Padma, her sister and their friends, as they do whatever it takes to stop their home from turning into a dysoptian society kept in check by a crazy despot with a murderous military at his command.<br><br>I\'m about 65% of the way through it, but I have put it aside to finish a few other things. I plan on picking it back up in 2024 to finish.',
        currentStatus: 'About 65% finished, but currently on hold while I work on the Sam Norris Series. It will be published at some point though.',
        heroDescription: '',
        freeGiveawayDescription: '',
        buyLink: '',
        buyButtonText: 'More Info',
        showBuyButton: false,
        paperbackBuyButtonText: 'Paperback',
        showPaperbackBuyButton: false,
        showBook: false,
        category: 'timeTravel',
        readingOrder: '6',
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 0,
        heroOrder: '1',
        next: false,
        nextDescription: '',
      },
    ],
  },
  {
    seriesName: 'Nightmares Through Time Short Stories',
    books: [
      {
        id: 15,
        seriesName: 'NTT Short Stories',
        bookNumber: 1,
        title: 'Origins - Volume 1',
        cover: '/images/Origins-Volume1.jpg',
        description: 'Book One in the Prequel Trilogy Novella Series, a Companion Trilogy to Nightmares Through Time',
        longDescription: '<b>He wanted a second chance.<br><br>But it could cost him his life.</b><br><br>Peter, a mid-twenties IT tech at a small software company, had been studying the secret of time travel. But he had grown weary of the possibility that it would ever happen, and his life would continue down the lonesome, boring path it was on.<br><br><b>Then one night his machine worked.</b><br><br>After an embarrassing first meeting with Anna, a new graphic designer, he decided to use his machine to change things, learn about her and do it all over.<br><br><b>But he wasn\'t the only one studying the secret.</b><br><br>Will he make things right with Anna? Can he save his best friend Zach? Or will enemies lurking closer to Peter than he knows disrupt his plans and take him down?<br><br>You\'ll love this time travel adventure as is moves across multiple timelines, throws shocking twists at you and will keep you turning pages well into the night.<br><br><b>Get it now.</b>',
        currentStatus: '',
        heroDescription: '',
        freeGiveawayDescription: 'Sam Norris Murder Mysteries',
        buyLink: 'https://dl.bookfunnel.com/iwm87hwyth',
        buyButtonText: 'Get Free!',
        showBuyButton: true,
        paperbackBuyButtonText: 'Paperback',
        showPaperbackBuyButton: false,
        showBook: true,
        category: 'timeTravel',
        readingOrder: '2',
        showInHero: false,
        showInFreeGiveaway: true,
        progress: 100,
        heroOrder: '1',
        next: false,
        nextDescription: '',
      },
      {
        id: 16,
        seriesName: 'NTT Short Stories',
        bookNumber: 2,
        title: 'Origins - Volume 2',
        cover: '/images/Origins-Volume2.jpg',
        description: '(IN PROGRESS)',
        longDescription: 'This book is currently in process.</br></br>Peter is trapped with a surprising enemy in Montana in 1873. He must work with the townspeople of Clayborne, Montana to keep the town from being destroyed.',
        currentStatus: 'Currently in progress, about 10% finished.',
        heroDescription: '',
        freeGiveawayDescription: '',
        buyLink: 'https://example.com/book8-buy',
        buyButtonText: 'Buy Now',
        showBuyButton: false,
        paperbackBuyButtonText: 'Paperback',
        showPaperbackBuyButton: false,
        showBook: false,
        category: 'timeTravel',
        readingOrder: '3',
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 0,
        heroOrder: '1',
        next: false,
        nextDescription: '',
      },
      {
        id: 17,
        title: 'Origins - Volume 3',
        seriesName: 'NTT Short Stories',
        bookNumber: 3,
        cover: '/images/Origins-Volume3.jpg',
        description: 'Book Nine Description',
        longDescription: 'This book should be available in 2024.',
        currentStatus: '',
        heroDescription: '',
        freeGiveawayDescription: '',
        buyLink: 'https://example.com/book9-buy',
        buyButtonText: 'Buy Now',
        showBuyButton: false,
        paperbackBuyButtonText: 'Paperback',
        showPaperbackBuyButton: false,
        showBook: false,
        category: 'timeTravel',
        readingOrder: '4',
        showInHero: false,
        showInFreeGiveaway: false,
        progress: 0,
        heroOrder: '1',
        next: false,
        nextDescription: '',
      },
    ],
  },
];

export default booksData;
